import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';

import { HttpMethod } from '@api/enums';
import { createHttpClient } from '@api/http-client';
import { END_POINTS } from '@constants/api-endpoints';
import { AlertType } from '@enums/alert';
import { showAlert } from '@lib/alert/alert-manager';
import { AppRoutes } from '@routes/constants';
import { LocalStorageKeys } from '@utils/auth';

export const useAuthCodeInSSO = ({ onSuccess }: { onSuccess: () => void }) => {
  const client = createHttpClient({ allowWithCredentials: false });
  const navigate = useNavigate();

  const mutation = useMutation(
    (data: { authCode: string }) =>
      client<{ accessToken: string }>({
        url: END_POINTS.AUTH.SSO_TOKEN,
        method: HttpMethod.POST,
        data,
      }),
    {
      onSuccess: responseData => {
        if (responseData?.accessToken) {
          localStorage.setItem(
            LocalStorageKeys.AUTH_TOKENS,
            JSON.stringify({ userToken: responseData.accessToken }),
          );
          navigate(AppRoutes.SELECT_WORKSPACE);

          return onSuccess();
        } else {
          showAlert({
            type: AlertType.ERROR,
            header: 'Authentication failed',
            message:
              'Unable to complete the sign-in process. Please try again.',
          });
          navigate(AppRoutes.LOGIN);
        }
      },
      onError: (error: Error) => {
        console.error('error', error);
        showAlert({
          type: AlertType.ERROR,
          header: 'Sign-in failed',
          message:
            'We were unable to complete your sign-in. Please try again or contact support if the problem persists.',
        });
        navigate(AppRoutes.LOGIN);
      },
    },
  );

  return mutation;
};
